"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const video_client_core_1 = require("@video/video-client-core");
const context_1 = require("../../../../context");
const Icon_1 = tslib_1.__importDefault(require("../../../../ui-lib/Buttons/Icon"));
const Icons_1 = tslib_1.__importDefault(require("../../../../ui-lib/Icons"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const ModularCameraButton = (0, mobx_react_lite_1.observer)(({ icon: ProvidedIcon, onClick, active, classes = {
    root: {},
    icon: {},
}, screenReaderText, label = "Toggle camera", ...props }) => {
    /**
     * Component Name (for error msg)
     */
    const componentName = "<CameraButton/>";
    /**
     * Access EncoderUiContext & destructure API state
     */
    const ctx = (0, react_1.useContext)(context_1.EncoderUiContext);
    /**
     * Throw error (and trigger ErrorBoundary) if store is undefined.
     * */
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.mediaStreamController) != null, componentName);
    /**
     * handleClick function wrapped in global Error handler (to trigger ErrorBoundary).
     * */
    const handleClick = onClick !== null && onClick !== void 0 ? onClick : (0, ErrorBoundary_1.useUIEventError)(() => video_client_core_1.adapter.device.toggleCameraVisibility(ctx.mediaStreamController), componentName);
    const activeState = (active !== null && active !== void 0 ? active : video_client_core_1.adapter.device.isIosDevice)
        ? !ctx.mediaStreamController.videoPaused
        : ctx.mediaStreamController.videoDisabled !== true;
    const icon = activeState ? (react_1.default.createElement(Icons_1.default, { iconName: "camera", classes: classes === null || classes === void 0 ? void 0 : classes.icon })) : (react_1.default.createElement(Icons_1.default, { iconName: "cameraoff", classes: classes === null || classes === void 0 ? void 0 : classes.icon }));
    return (react_1.default.createElement(Icon_1.default, { active: activeState, "data-selenium": "camera-toggle-button", icon: ProvidedIcon !== null && ProvidedIcon !== void 0 ? ProvidedIcon : icon, onClick: handleClick, classes: classes, label: label, disabled: ctx.mediaStreamController.videoDeviceId == null || ctx.mediaStreamController.videoDisabled === "placeholder", ...props }, screenReaderText !== null && screenReaderText !== void 0 ? screenReaderText : `Click to turn Camera Stream ${activeState ? "Off" : "On"}`));
});
/**
 *
 * @visibleName Camera Button
 */
function CameraButtonWithErrorBoundary({ icon: ProvidedIcon, classes, label = "Toggle camera", screenReaderText, ...props }) {
    const icon = ProvidedIcon !== null && ProvidedIcon !== void 0 ? ProvidedIcon : react_1.default.createElement(Icons_1.default, { iconName: "camera", classes: classes === null || classes === void 0 ? void 0 : classes.icon });
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => (react_1.default.createElement(Icon_1.default, { "data-selenium": "camera-toggle-button", disabled: true, classes: classes, icon: icon, label: label, onClick: undefined, active: false, ...props }, screenReaderText !== null && screenReaderText !== void 0 ? screenReaderText : "Click to turn Camera Stream On")) },
        react_1.default.createElement(ModularCameraButton, { classes: classes, icon: ProvidedIcon, label: label, screenReaderText: screenReaderText, ...props })));
}
exports.default = CameraButtonWithErrorBoundary;
//# sourceMappingURL=Camera.js.map